import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../../store';


@customElement('model-overview')
export class ModelOverview extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
				margin: 0 var(--specsheet-large-gap) var(--specsheet-medium-gap) var(--specsheet-large-gap);
				font: var(--font-specsheet-small-text);
			}

			.imageSection {
				max-width: 100%;
				height: 432px;
				margin-top: 60px;
			}

			.imagesContainer {
				height: 100%;
			}

			.img {
				display: inline-block;
				width: calc(33.33% - 20px);
				height: 100%;
				margin-right: 20px;
				object-fit: cover;
			}

			.img:last-child {
				margin-right: 0;
			}

			.tableDataContainer {
				display: table;
				width: 100%;
				margin-bottom: 10vh;

				.description {
					display: table-cell;
					width: 50%;
				}

				.featuresTable {
					display: table-cell;
					width: 50%;

					.featureTableCell .row {
						border-bottom: 1px solid black;
					}

					.featureTableCell.single .row {
						border-bottom: 1px solid black;
					}
				}
			}

			@media print {
				:host {
					padding-top: 2vw;
					width: 100vw;
					margin: 0;
					font: var(--font-specsheet-print-small-text);
				}

				.imageSection {
					max-width: 100%;
					height: 30vh;
					margin-top: 0px;
				}

				.imagesContainer {
					height: 100%;
				}

				.img {
					display: inline-block;
					width: calc(33.33% - 20px);
					height: 100%;
					margin-right: 20px;
					object-fit: cover;
				}

				.img:last-child {
					margin-right: 0;
				}

				.coverTable {
					font: var(--font-specsheet-print-small-text);
				}
			}

		`]
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		if (state.specsheet.data.specsheets && state.status?.productFamily) {
			this.kirbySpecsheets = state.specsheet.data.specsheets;
			this.family = state.status.productFamily;
			this.kirbySpecsheet = this.kirbySpecsheets.find(specsheet => specsheet.id === this.family);
			this.usps = this.kirbySpecsheet?.usps;
		}
	}

	render() {
		if (!this.kirbySpecsheet) return html``;

		return html`
			<div class="summary">
				<section class="imageSection">
					<div class="imagesContainer">
						${when(this.kirbySpecsheet.model_image_1, () => html`
							<img class="img" src=${this.kirbySpecsheet.model_image_1}/>
						`, () => html``)}
						${when(this.kirbySpecsheet.model_image_2, () => html`
							<img class="img" src=${this.kirbySpecsheet.model_image_2}/>
						`, () =>  html``)}
						${when(this.kirbySpecsheet.model_image_3, () => html`
							<img class="img" src=${this.kirbySpecsheet.model_image_3}/>
						`, () => html``)}
					</div>
				</section>
				<section class="tableData">
					<div class="tableDataContainer">
						<div class="coverTable">
							${this.usps.map((usp) => html`
								<cover-table title="${usp.usp_title}">
									${usp.usp.map((item, index) => html`
										<cover-table-item style-choice="${index === usp.usp.length - 1 ? 'no-border' : ''}">
											<div slot="label">${item.usp_title}</div>
											<div slot="value">${item.usp_description}</div>
										</cover-table-item>
									`)}
								</cover-table>
							`)}

						</div>
					</div>

				</section>
			</div>
		`;
	}
}
